import { gql } from '@apollo/client';

export const DEL_IMAGE = gql`
  mutation delImage($input: ImageInput!) {
    delImage(input: $input)
  }
`;